import { Key } from 'react'
import { ScheduledContent } from '../../ScheduleContent'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Button } from 'blaze-ui/Button'
import { Menu } from 'components/Menu/Menu'
import { Item } from '@react-stately/collections'
import { Edit1, ImageAdd, Images, Templates, Trash2 } from 'blaze-ui/icons'
import Styles from './EditMenu.module.scss'

interface Props {
  content: ScheduledContent
  onAction: (key: Key, uuid: string) => void
}

export enum EditKey {
  ChangeAddImage = 'change-add-image',
  ChangeTemplate = 'change-template',
  EditCaption = 'edit-caption',
  Delete = 'delete,',
}

export const EditMenu = ({ content, onAction }: Props) => {
  const { uuid, hasReplaceableImage, initialMediaFileId, width, height } = content

  const isDesign = Boolean(width && height)

  return (
    <MenuTrigger placement="bottom-end">
      <Button variant="tertiary" withChevron="down" size="sm">
        Edit
      </Button>
      <Menu onAction={(key) => onAction(key, uuid)}>
        {hasReplaceableImage && !initialMediaFileId && (
          <Item key={EditKey.ChangeAddImage} textValue="Add Image">
            <div className={Styles.menuItem}>
              <ImageAdd />
              <span>Add Image</span>
            </div>
          </Item>
        )}
        {hasReplaceableImage && initialMediaFileId && (
          <Item key={EditKey.ChangeAddImage} textValue="Change Image">
            <div className={Styles.menuItem}>
              <Images />
              <span>Change Image</span>
            </div>
          </Item>
        )}
        {isDesign && (
          <Item key={EditKey.ChangeTemplate} textValue="Change Template">
            <div className={Styles.menuItem}>
              <Templates />
              <span>Change Template</span>
            </div>
          </Item>
        )}
        <Item key={EditKey.EditCaption} textValue="Edit">
          <div className={Styles.menuItem}>
            <Edit1 />
            <span>Edit Caption</span>
          </div>
        </Item>
        <Item key={EditKey.Delete} textValue="Delete">
          <div className={Styles.menuItem}>
            <Trash2 />
            <span>Delete</span>
          </div>
        </Item>
      </Menu>
    </MenuTrigger>
  )
}
